import React, { useEffect, useContext, useState, useRef } from 'react'
import { Carousel } from 'antd'
import { PlayerContext } from '@store/player'
import styles from './index.less'

function Home() {
  const { state, dispatch } = useContext(PlayerContext)
  const [songProcess, setSongProcess] = useState(0)
  const timer = useRef(null)

  const bannerList = [
    require('@images/banner-1.png'),
    require('@images/banner-2.png'),
    require('@images/banner-3.png'),
    require('@images/banner-4.png'),
  ]

  const songList = [
    {
      id: 1,
      img: require('@images/song-1.png'),
      name: '我们俩',
      singer: '郭顶',
      duration: '03:13',
    },
    {
      id: 2,
      img: require('@images/song-2.png'),
      name: '椿',
      singer: '沈以诚',
      duration: '03:37',
    },
    // {
    //   id: 32215698,
    //   img: require('@images/32215698.png'),
    //   name: '小希望',
    //   singer: '郭顶',
    // },
    // {
    //   id: 351358073,
    //   img: require('@images/song-2.jpg'),
    //   name: '形容',
    //   singer: '沈以诚',
    // },
    {
      id: 3,
      img: require('@images/song-3.jpg'),
      name: '时光洪流',
      singer: '程响',
      duration: '04:11',
    },
    {
      id: 4,
      img: require('@images/song-4.jpg'),
      name: '哪里都是你',
      singer: '队长',
      duration: '03:42',
    },
    {
      id: 5,
      img: require('@images/song-5.jpg'),
      name: '这世界那么多人',
      singer: '莫文蔚',
      duration: '04:45',
    },
  ]

  useEffect(() => {
    console.log('useEffect')
    const player = document.getElementById('player')
    if (player) {
      timer.current = setInterval(function () {
        setSongProcess(player.currentTime ? (100 * player.currentTime) / player.duration : 0)
      }, 200)
      return function () {
        if (timer.current) {
          clearInterval(timer.current)
        }
      }
    }
  }, [])

  function handleClick(id) {
    setSongProcess(0)
    if (id === state.current) {
      const player = document.getElementById('player')
      if (player.paused) {
        player.play()
      } else {
        player.pause()
      }
    } else {
      dispatch({ type: 'setCurrent', current: id })
    }
  }

  return (
    <div className={styles['home']}>
      <div className={styles['banner']}>
        <Carousel effect="fade" autoplay dots={false}>
          {bannerList.map((item) => {
            return (
              <div className={styles['banner-img']} key={item}>
                <img src={item} alt="" />
              </div>
            )
          })}
        </Carousel>
      </div>
      <div className={styles['content']}>
        <div className={styles['content-song']}>
          <div className={styles['song-list']}>
            {songList.map((item) => {
              return (
                <div
                  className={`${styles['list-item']} ${state.current === item.id ? styles['active'] : ''}`}
                  key={item.name}
                  onClick={() => {
                    handleClick(item.id)
                  }}
                >
                  <div className={styles['item-process']} style={{ width: `${songProcess}%` }}></div>
                  <div className={styles['item-img']}>
                    <img src={item.img} alt="" />
                  </div>
                  <div className={styles['item-name']}>{item.name}</div>
                  <div className={styles['item-singer']}>{item.singer}</div>
                  <div className={styles['item-duration']}>{item.duration}</div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
